export default "__VITE_ASSET__BFYwQhQz__"